/* eslint-disable */

import React, { useEffect } from "react";
import LeafletMap from "./../shared/components/LeafletMap";
import APIClient from "./client";
import CFTranslateFunction from "./translations";
import Legend from "./components/Legend";
import CustomSearchBox from "./components/CustomSearchBox";
import CustomSortingSelector from "./components/CustomSortingSelector";
import "searchkit-datefilter/release/theme.css";
import moment from "moment";

import DatasetListItem from "./components/DatasetListItem";
import DatasetDropZoneModal from "./components/DatasetDropZone";
import LinkJohnDeere from "./components/JohnDeere";
import LinkAGCO from "./components/AGCO";
import LinkDroneWerkers from "./components/Dronewerkers";
import MultiSelect from "searchkit-multiselect";
import {
  BoolMustNot,
  BoolShould,
  FastClick,
  Hits,
  HitsStats,
  Pagination,
  RefinementListFilter,
  ResetFilters,
  SearchkitManager,
  SearchkitProvider,
  SelectedFilters,
  TermQuery,
  TermsQuery,
} from "searchkit";
import { DateRangeCalendar, DateRangeFilter } from "searchkit-datefilter";
import "./stylesheets/cloudfarm-r.scss";
import "./stylesheets/searchkit.scss";
import _ from "underscore";

import cropr from "../shared/utils/cropr";
import gettext from "../shared/utils/gettext";
import { $, interpolate, Model, View } from "../shared/utils/legacy";
import LinkAVR from "./components/AVR";
import LinkVervaet from "./components/Vervaet";
import LinkAgriRouter from "./components/AgriRouter";
import FieldView from "./components/FieldView";
import { initMoment } from "../shared/utils/i18n";
import LinkRaindancer from "./components/Raindancer";
import LinkTrimble from "./components/Trimble";
import LinkCNH from "./components/CNH";
import LinkClaasConnect from "./components/ClaasConnect";

class Cloudfarm extends React.Component {
  state = {
    selectedDatasets: [],
    selectedMeasurementLayers: [],
    showFilter: false,
    selectedCropfields: [],
    activeView: "datasets",
    titleText: null,
    collapsed: false,
  };

  constructor() {
    super();
    initMoment();
    const host = cropr.cloudfarm_domain + "/api/data/datasets/elasticsearch";
    this.searchkit = new SearchkitManager(host, {
      httpHeaders: { Authorization: "Bearer " + cropr.cloudfarm_oauth_token },
      timeout: 10000,
      searchOnLoad: false,
    });
    this.searchkit.translateFunction = CFTranslateFunction;
    this.searchkit.addDefaultQuery((query) => {
      return query.addQuery(
        BoolShould([
          TermQuery("data_set_rois.roi_grp_id.keyword", cropr.getActivePlan().get("did")),
          BoolMustNot(TermsQuery("data_format.keyword", ["n"])),
        ])
      );
    });
    this.cropfieldsReady = false;
    if (_) {
      _.noConflict();
    }
  }

  componentDidMount() {
    if (cropr && cropr.l10n) moment.locale(cropr.l10n.languageCode);
    if (_) {
      cropr.shareView = new View.DacomShareView({
        el: $("#dacomShareModal"),
        share_type: "cloudfarm",
      });
      cropr.recording = new View.Recording({
        el: $("#recordingPopup"),
        model: new Model.Record(),
        cropfields: cropr.cropfields,
        groups: cropr.groups,
      });
      cropr.stockView = new View.RecordEditStockView({
        el: $("#popover_container"),
      });
      cropr.NewCoWorkerView = new View.NewCoWorkerView({
        el: $("#contact_popover_container"),
      });
      cropr.NewMachineView = new View.NewMachineView({
        el: $("#machine_popover_container"),
      });
    }
    this.offResult = this.searchkit.addResultsListener(() => {
      if (this.searchkit.accessors.statefulAccessors.cropfields) {
        this.setState({
          selectedCropfields:
            this.searchkit.accessors.statefulAccessors.cropfields.state.value || [],
        });
      }
    });
  }

  onCropfieldsReady = () => {
    if (!this.cropfieldsReady) {
      this.cropfieldsReady = true;
      this.forceUpdate(() => {
        this.searchkit.search();
      });
    }
  };
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.activeView === "cropfield" && this.state.activeView === "datasets") {
      this.searchkit.reloadSearch();
    }
  }

  componentWillUnmount() {
    if (this.offResult) {
      this.offResult();
      delete this.offResult;
    }
  }

  setTitleText = (txt) => {
    this.setState({ titleText: txt });
  };

  clearMeasurementLayers = () => {
    this.setState({ selectedMeasurementLayers: [] });
  };

  setImageLocation = (imageLocation) => {
    if (!imageLocation) {
      this.clearMeasurementLayers();
      return;
    }
    const measurementLayer = {
      data: {
        legend: imageLocation.legend,
        url: imageLocation.url,
        bounding_box: imageLocation.bounds,
      },
      measurement: {
        name: imageLocation.name,
        display_name: imageLocation.display_name || imageLocation.name,
        id: imageLocation.measurement_id || imageLocation.name,
      },
      ds: {
        recording_datetime: imageLocation.date,
        data_type: imageLocation.data_type,
        uuid: `${imageLocation.data_type}_${imageLocation.date}`,
        clearOnToggle: true,
        mappings: imageLocation.mappings,
      },
      layer: {
        cropfield: imageLocation.cropfield,
      },
      layerId: imageLocation.cropfield.get("did"),
      measurementId: imageLocation.measurement_id || imageLocation.name,
      dsUuid: `${imageLocation.data_type}_${imageLocation.date}`,
    };
    measurementLayer.ds.dataset_measurements = [measurementLayer.measurement];
    this.setState({ selectedMeasurementLayers: [measurementLayer] });
  };

  toggleMeasurementLayer = (ds, measurement, layer) => {
    if (ds.clearOnToggle) {
      this.clearMeasurementLayers();
      return;
    }
    let dsUuid = ds.uuid,
      measurementId = measurement.id,
      layerId = layer ? layer.id : "";
    let selectedMeasurementLayers = this.state.selectedMeasurementLayers.slice();
    let measurementLayer = selectedMeasurementLayers.find(
      (sml) =>
        sml.dsUuid === dsUuid && sml.measurementId === measurementId && sml.layerId === layerId
    );
    if (measurementLayer) {
      selectedMeasurementLayers.splice(selectedMeasurementLayers.indexOf(measurementLayer), 1);
    } else {
      measurementLayer = {
        dsUuid: dsUuid,
        measurementId: measurementId,
        layerId: layerId,
        ds: ds,
        measurement: measurement,
        layer: layer,
      };
      selectedMeasurementLayers.push(measurementLayer);
      this.loadMeasurementLayer(measurementLayer);
    }
    this.setState({ selectedMeasurementLayers: selectedMeasurementLayers });
  };

  updateMeasurementLayer = (measurementLayer, data, opacity) => {
    const selectedMeasurementLayers = this.state.selectedMeasurementLayers.slice();
    const selectedMeasurementLayer = selectedMeasurementLayers.find(
      (sml) =>
        sml.dsUuid === measurementLayer.dsUuid &&
        sml.measurementId === measurementLayer.measurementId &&
        sml.layerId === measurementLayer.layerId
    );
    if (selectedMeasurementLayer) {
      if (data) {
        selectedMeasurementLayer.data = data;
      }
      if (opacity) {
        selectedMeasurementLayer.opacity = opacity;
      }
      this.setState({ selectedMeasurementLayers: selectedMeasurementLayers });
    }
  };
  reloadMeasurementLayer = (measurementLayer, imageType, ignore_0) => {
    this.loadMeasurementLayer(measurementLayer, imageType, ignore_0);
  };

  async loadMeasurementLayer(measurementLayer, imageType, ignore_0) {
    if (ignore_0 === undefined) {
      ignore_0 = true;
    }
    let path =
      "/api/data/datasets/" +
      measurementLayer.dsUuid +
      "/measurements/" +
      measurementLayer.measurementId +
      (measurementLayer.layerId ? "/layers/" + measurementLayer.layerId + "/" : "/");
    let payLoad = { ignore_0: !!ignore_0 };
    const similar = this.state.selectedMeasurementLayers.find(
      (sml) => sml.measurement.name === measurementLayer.measurement.name && sml.data
    );
    if (similar && similar.data.legend && similar.data.legend.length === 5) {
      payLoad.min = similar.data.legend[4].min;
      payLoad.max = similar.data.legend[0].max;
    }
    if (imageType) {
      payLoad.imageType = imageType;
    }
    let data = await APIClient.get(path, payLoad, cropr.cloudfarm_oauth_token);
    this.updateMeasurementLayer(measurementLayer, data);
  }

  dragOn = () => {
    this.setState({ showDropZone: true });
  };
  dragOff = () => {
    this.setState({ showDropZone: false });
  };

  reloadSearch = (timeout) => {
    setTimeout(() => {
      this.searchkit.reloadSearch();
    }, timeout || 2000);
  };

  updateSelectedCropfields = (cf) => {
    let selectedCropfields = this.state.selectedCropfields.slice();
    let indexOf = selectedCropfields.indexOf(cf.get("did"));
    if (indexOf === -1) {
      selectedCropfields.push(cf.get("did"));
    } else {
      selectedCropfields.splice(indexOf, 1);
    }
    this.searchkit.accessors.statefulAccessors.cropfields.state.value = selectedCropfields;
    this.searchkit.reloadSearch();
    this.setState({ selectedCropfields: selectedCropfields });
  };

  handleSelect = (e, dsUuid) => {
    e.stopPropagation();
    const selectedDatasets = this.state.selectedDatasets.slice();
    let idx = selectedDatasets.indexOf(dsUuid);
    if (idx > -1) {
      selectedDatasets.splice(idx, 1);
    }
    if (e.target.checked) {
      selectedDatasets.push(dsUuid);
    }
    this.setState({ selectedDatasets: selectedDatasets });
  };

  removeSelectedDatasets = () => {
    const selectedDatasets = this.state.selectedDatasets.slice();
    if (
      cropr.confirm(
        interpolate(gettext("Are you sure you want te delete the %s selected dataset(s)?"), [
          selectedDatasets.length,
        ])
      )
    ) {
      selectedDatasets.forEach((dsUuid) => {
        APIClient.remove("/api/data/datasets/" + dsUuid + "/", null, cropr.cloudfarm_oauth_token);
      });
      let selectedMeasurementLayers = this.state.selectedMeasurementLayers.slice();
      selectedMeasurementLayers = selectedMeasurementLayers.filter(
        (sml) => selectedDatasets.indexOf(sml.dsUuid) < 0
      );
      this.setState({ selectedDatasets: [], selectedMeasurementLayers: selectedMeasurementLayers });
      this.reloadSearch();
    }
  };

  toggleFilter = () => {
    this.setState({ showFilter: !this.state.showFilter });
  };

  toggleCollapse = () => {
    this.setState({ collapsed: !this.state.collapsed });
  };

  shareDataset = () => {
    cropr.shareView.render(this.state.selectedDatasets);
  };

  render() {
    const selectedMeasurements =
      this.searchkit.accessors.statefulAccessors &&
      this.searchkit.accessors.statefulAccessors.measurements &&
      this.searchkit.accessors.statefulAccessors.measurements.state.value
        ? this.searchkit.accessors.statefulAccessors.measurements.state.value
        : [];
    const topbarElement = document.getElementById("topbar");
    const outerHeight = topbarElement
      ? topbarElement.offsetHeight +
        parseFloat(window.getComputedStyle(topbarElement).marginTop) +
        parseFloat(window.getComputedStyle(topbarElement).marginBottom)
      : 0;
    const mapOffset = 56 + outerHeight;
    return (
      <SearchkitProvider searchkit={this.searchkit}>
        <div
          className={"full-height container-fluid pl-0 pr-0"}
          onDragOver={this.dragOn}
          onDragLeave={this.dragOff}
        >
          <div className="row container-fluid bg-white pt-2 pb-2 pr-0 pl-0 ml-0">
            <div className="col-12">
              {this.state.activeView === "datasets" ? (
                <>
                  <div className="mw-160px float-left mr-1">
                    <CustomSearchBox
                      autofocus={true}
                      placeholder={gettext("Search datasets")}
                      searchOnChange={true}
                      prefixQueryFields={["name"]}
                      style={{ paddingTop: "5px" }}
                      queryFields={["name", "uuid"]}
                    />
                  </div>
                  <div className="float-left mr-1">
                    <CustomSortingSelector
                      options={[
                        {
                          label: gettext("Latest added"),
                          field: "created",
                          order: "desc",
                        },
                        {
                          label: gettext("Newest"),
                          field: "recording_datetime",
                          order: "desc",
                        },
                      ]}
                    />
                  </div>
                  <div className="dropdown mr-1 float-left">
                    <a
                      className="btn btn-default dropdown-toggle dfi-btn"
                      data-toggle="dropdown"
                      id="grid-btn-record"
                    >
                      <i className="icn_add-rounded" />
                      <span className="caret" />
                    </a>
                    <div className="dropdown-menu" aria-labelledby="grid-btn-record">
                      <DatasetDropZoneModal
                        showModal={this.state.showDropZone}
                        handleHide={this.dragOff}
                        handleShow={this.dragOn}
                        handleReload={this.reloadSearch}
                      />
                      <LinkAGCO />
                      <LinkJohnDeere />
                      <LinkDroneWerkers />
                      <LinkAVR />
                      <LinkVervaet />
                      <LinkAgriRouter />
                      <LinkRaindancer />
                      <LinkClaasConnect />
                      <LinkCNH />
                      {cropr.getConfig("experiments", "trimble", true) && <LinkTrimble />}
                    </div>
                  </div>
                  <a
                    className="btn btn-default dfi-btn bg-light mr-1 rounded-lg d-inline-block float-left "
                    style={{ width: "52px" }}
                    onClick={this.toggleFilter}
                    role="button"
                  >
                    <i className="icn_filters" />
                  </a>

                  {this.state.selectedDatasets.length > 0 ? (
                    <div className="float-left">
                      <a
                        className="btn btn-default bg-light rounded-lg d-inline-block mr-1"
                        style={{ width: "52px" }}
                        onClick={this.removeSelectedDatasets}
                      >
                        <i className="fas fa-trash-alt" />
                      </a>
                      <a
                        className="btn btn-default bg-light rounded-lg d-inline-block mr-1"
                        style={{ width: "52px" }}
                        onClick={this.shareDataset}
                      >
                        <i className="fas fa-share-square" />
                      </a>
                    </div>
                  ) : null}
                  <div
                    className={
                      "collapsed text-justify collapse sticky-top z-index-1003 float-left" +
                      (this.searchkit.query.getSelectedFilters().length > 0 ? " show" : "")
                    }
                  >
                    <ul className="items d-inline-flex list-inline mb-0">
                      <SelectedFilters itemComponent={CFFilterItem} />
                    </ul>
                    <ResetFilters component={CFResetFiltersDisplay} />
                  </div>
                </>
              ) : (
                <div className="float-left">
                  <h3>{this.state.titleText}</h3>
                </div>
              )}
              <div className="d-inline-block float-right">
                <div className="btn-group">
                  <button
                    className={
                      "btn btn-outline-smoke " +
                      (this.state.activeView === "datasets" ? "active" : "")
                    }
                    onClick={() => this.setState({ activeView: "datasets" })}
                  >
                    <i className={"far fa-database pr-1"}> </i>
                    {gettext("datasets")}
                  </button>
                  <button
                    className={
                      "btn btn-outline-smoke " +
                      (this.state.activeView === "cropfield" ? "active" : "")
                    }
                    onClick={() => this.setState({ activeView: "cropfield" })}
                  >
                    <i className={"far fa-map-marked pr-1"}> </i>
                    {gettext("cropfield")}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="row no-gutters" style={{ height: `calc(100vh - ${mapOffset}px)` }}>
            {this.state.activeView === "datasets" ? (
              <>
                <div
                  className="position-absolute w-360px"
                  style={{
                    top: "51px",
                    height: "calc(100vh - " + mapOffset + "px)",
                    zIndex: 1000,
                    left: this.state.collapsed ? "-342px" : "0px",
                    transition: "all 0.2s ease",
                  }}
                >
                  <button
                    className="btn btn-circle btn-smoke position-absolute"
                    style={{ top: "50%", right: "-15px", zIndex: 1500 }}
                    onClick={this.toggleCollapse}
                  >
                    <i
                      className={
                        "far " + (this.state.collapsed ? "fa-chevron-right" : "fa-chevron-left")
                      }
                    >
                      {" "}
                    </i>
                  </button>
                  <div id="stream" className="stream-has-options full-height d-flex flex-column">
                    <div className="row pl-5 pt-1">
                      <HitsStats />
                    </div>

                    {!this.state.collapsed && (
                      <div id="stream-wrapper" className="pb-2 position-relative flex-grow-1">
                        <Hits
                          hitsPerPage={100}
                          itemComponent={
                            <ConnectedDatasetListItem
                              onToggle={this.toggleMeasurementLayer}
                              handleSelect={this.handleSelect}
                              selectedMeasurementLayers={this.state.selectedMeasurementLayers}
                              selectedCropfields={this.state.selectedCropfields}
                              selectedMeasurements={selectedMeasurements}
                              handleReload={this.reloadSearch}
                            />
                          }
                        />
                        <Pagination showNumbers={true} />
                      </div>
                    )}
                  </div>
                  <div
                    className={
                      "slide-panel slide-right" + (this.state.showFilter ? " slide-panel-show" : "")
                    }
                    id="cloudfarm-sidebar"
                    style={{ width: "280px", right: this.state.showFilter ? "-280px" : 0 }}
                  >
                    <div className="slide-panel-wrapper">
                      <div className="slide-panel-header bg-white pt-1" style={{ height: "50px" }}>
                        <h5 className="float-left">Filters</h5>
                        <div
                          className="btn btn-icon btn-filters-close btn-trans float-right"
                          onClick={this.toggleFilter}
                        >
                          <i className="icn_cross" /> <span>{gettext("Close")}</span>
                        </div>
                      </div>
                      <div
                        className="slide-panel-content overflow-auto pb-2 pt-3"
                        style={{ top: "50px" }}
                      >
                        <div id="sidebar-content">
                          <RefinementListFilter
                            id="cropfields"
                            title={gettext("Crop fields")}
                            field="data_set_rois.roi.keyword"
                            operator="OR"
                            listComponent={MultiSelect}
                            include={
                              cropr.cropfields.length < 1500
                                ? cropr.cropfields.map((cf) => cf.get("did"))
                                : []
                            }
                            size={500}
                          />

                          <RefinementListFilter
                            id="datatype"
                            title={gettext("Type")}
                            field="data_type.keyword"
                            operator="OR"
                            size={10}
                          />
                          <RefinementListFilter
                            id="devices"
                            title={gettext("Machine")}
                            field="dataset_measurements.device.keyword"
                            operator="OR"
                            size={10}
                          />
                          <RefinementListFilter
                            id="measurements"
                            title={gettext("Measurements")}
                            field="dataset_measurements.name.keyword"
                            operator="OR"
                            size={10}
                          />
                          <DateRangeFilter
                            id="recording_datetime"
                            title={gettext("Recording date")}
                            fromDateField="recording_datetime"
                            toDateField="recording_datetime"
                            calendarComponent={LabeledDateRangeCalendar}
                          />
                          <DateRangeFilter
                            id="created"
                            title={gettext("Created")}
                            fromDateField="created"
                            toDateField="created"
                            calendarComponent={LabeledDateRangeCalendar}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-12">
                  <LeafletMap
                    locations={this.state.selectedMeasurementLayers
                      .filter((sml) => sml.data)
                      .map((sml) => ({
                        type: "image",
                        url: sml.data.url,
                        bounds: sml.data.bounding_box,
                        zoomTo: true,
                        opacity: sml.opacity || 1,
                        measurementLayer: sml,
                        key: sml.dsUuid + sml.measurementId + sml.layerId,
                      }))}
                    extraLayers={true}
                    showFields={true}
                    updateSelectedCropfields={this.updateSelectedCropfields}
                    selectedCropfields={this.state.selectedCropfields}
                    height={`calc(100vh - ${mapOffset}px)`}
                    onCropfieldsReady={this.onCropfieldsReady}
                  />
                </div>
              </>
            ) : (
              <div className="col-12">
                <FieldView
                  setTitleText={this.setTitleText}
                  toggleMeasurementLayer={this.toggleMeasurementLayer}
                  clearMeasurementLayers={this.clearMeasurementLayers}
                  selectedMeasurementLayers={this.state.selectedMeasurementLayers}
                  setImageLocation={this.setImageLocation}
                />
              </div>
            )}
            <div id="cloudfarm_map_legends" style={{ zIndex: 500 }}>
              <ul
                className="legend-container"
                style={{
                  bottom: this.state.activeView === "datasets" ? "40px" : "120px",
                  maxHeight: this.state.activeView === "datasets" ? "72vh" : "60vh",
                }}
              >
                {this.state.selectedMeasurementLayers
                  .filter((sml) => sml.data)
                  .map((sml) => (
                    <Legend
                      key={sml.dsUuid + sml.measurementId + sml.layerId}
                      measurementLayer={sml}
                      otherMeasurementLayers={this.state.selectedMeasurementLayers.filter(
                        (osml) => osml !== sml
                      )}
                      toggleMeasurementLayer={this.toggleMeasurementLayer}
                      loadMeasurementLayer={this.reloadMeasurementLayer}
                      updateMeasurementLayer={this.updateMeasurementLayer}
                      handleReload={this.reloadSearch}
                    />
                  ))}
              </ul>
            </div>
          </div>
        </div>
      </SearchkitProvider>
    );
  }
}

const ConnectedDatasetListItem = ({
  onToggle,
  handleSelect,
  selectedMeasurementLayers,
  result,
  selectedCropfields,
  selectedMeasurements,
  handleReload,
}) => (
  <DatasetListItem
    uuid={result._source.uuid}
    result={result}
    toggleMeasurementLayer={onToggle}
    handleSelect={handleSelect}
    selectedMeasurementLayers={selectedMeasurementLayers.filter(
      (v) => v.dsUuid === result._source.uuid
    )}
    selectedCropfields={selectedCropfields}
    selectedMeasurements={selectedMeasurements}
    handleReload={handleReload}
  />
);

const LabeledDateRangeCalendar = (props) => (
  <DateRangeCalendar
    {...props}
    fromLabel={gettext("From")}
    toLabel={gettext("To")}
    containerId="cloudfarm-sidebar"
  />
);

const CFFilterItem = (props) => {
  let cropfield = null;
  if (props.filterId === "cropfields") {
    cropfield = cropr.cropfields.findWhere({ name: props.labelValue });
  }
  return (
    <li className="item border border-2 rounded-pill p-1 list-inline-item">
      {cropfield ? (
        <span
          className="parcel-image"
          dangerouslySetInnerHTML={{
            __html: cropfield.getImageTag({
              size: 24,
              class: "left",
            }),
          }}
        />
      ) : null}
      <span>{props.labelValue}</span>
      <FastClick handler={props.removeFilter}>
        <i className="icn_cross" style={{ cursor: "pointer" }} />
      </FastClick>
    </li>
  );
};

const CFResetFiltersDisplay = (props) => {
  const { resetFilters } = props;
  return (
    <a
      className="close-btn text-uppercase float-right text-decoration-none d-inline-block mt-1 text-black--120"
      href="#"
    >
      <FastClick handler={resetFilters}>
        <span>{gettext("reset")}</span>
      </FastClick>
    </a>
  );
};

if (!_ || _.contains) {
  _.noConflict();
}

export default Cloudfarm;
